<template>
  <b-alert show variant="danger" class="py-2">
    <b-row align-h="center">
      <b-col cols="10">
        <span class="text-grey">
            {{ $t('bars.has_pending_payment') }}
        </span>
        <b-btn variant="danger" size="sm" @click="seeDetails"
               class="mx-2 text-white upgrade-plan">
          {{ $t('bars.details') }}
        </b-btn>
      </b-col>
    </b-row>
  </b-alert>
</template>

<script>
export default {
  name: "HasPendingPaymentBar",
  methods: {
    seeDetails() {
      this.$router.push({name:'settings', query:  {tab: 'subscription', tm: + new Date()}})
    }
  }
}
</script>

<style scoped>
</style>